import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { IExamStatsByAnswerRate } from "../../../models/statistics.model";
import { upperCase } from "lodash";

interface IProps {
  data: IExamStatsByAnswerRate[]|undefined;
  hasEAnswer: boolean|undefined;
}

const ExamAnswerRateTable: FC<IProps> = ({
  data,
  hasEAnswer
}) => {
  const { t } = useTranslation();
  return data?.length
    ? (
      <div className="comm-table__area rowType stats">
        <table>
          <tbody>
            <tr>
              <th rowSpan={2}>{t('statistics.placementTest.column8')}</th>
              <th rowSpan={2}>Skill</th>
              <th rowSpan={2}>{t('statistics.placementTest.column11')}</th>
              <th colSpan={3}>{t('statistics.regularTest.column3')}</th>
              <th colSpan={hasEAnswer?5:4}>{t('statistics.regularTest.column4')}</th>
            </tr>
            <tr>
              <th>Top(27%)</th>
              <th>Bottom(27%)</th>
              <th>{t('statistics.regularTest.column5')}</th>
              <th>A</th>
              <th>B</th>
              <th>C</th>
              <th>D</th>
              {hasEAnswer?<th>E</th>:null}
            </tr>
            {data?.map((item, index) => (
              <>
                <tr>
                  <td>{index + 1}</td>
                  <td>{item.skillName}</td>
                  <td>{item.correctAnswerRate.toFixed(2)}</td>
                  <td>{item.correctTopAnswerRate.toFixed(2)}</td>
                  <td>{item.correctBottomAnswerRate.toFixed(2)}</td>
                  <td>{((Math.floor(item.correctTopAnswerRate) - Math.floor(item.correctBottomAnswerRate)) / 100).toFixed(2)}</td>
                  <td>{(upperCase(item.correctAnswerHigh) === 'A')?<span style={{color:'red', fontWeight:'bold'}}>{item.answerPera.toFixed(2)}</span>:<>{item.answerPera.toFixed(2)}</>}</td>
                  <td>{(upperCase(item.correctAnswerHigh) === 'B')?<span style={{color:'red', fontWeight:'bold'}}>{item.answerPerb.toFixed(2)}</span>:<>{item.answerPerb.toFixed(2)}</>}</td>
                  <td>{(upperCase(item.correctAnswerHigh) === 'C')?<span style={{color:'red', fontWeight:'bold'}}>{item.answerPerc.toFixed(2)}</span>:<>{item.answerPerc.toFixed(2)}</>}</td>
                  <td>{(upperCase(item.correctAnswerHigh) === 'D')?<span style={{color:'red', fontWeight:'bold'}}>{item.answerPerd.toFixed(2)}</span>:<>{item.answerPerd.toFixed(2)}</>}</td>
                  {hasEAnswer?<td>{(upperCase(item.correctAnswerHigh) === 'E')?<span style={{color:'red', fontWeight:'bold'}}>{item.answerPere.toFixed(2)}</span>:<>{item.answerPere.toFixed(2)}</>}</td>:null}
                </tr>
              </>
            ))}
          </tbody>
        </table>
      </div>
      )
    : null
}

export default ExamAnswerRateTable;
